<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">

        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="plate"
          clearable
        >
        </el-input>
        <span class="fonints">派车时间</span>
        <!-- <el-date-picker
          v-model="datamsg"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker> -->
        <el-date-picker
            v-model="startday"
            type="datetime"
            style="width: 180px;"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始日期">
          </el-date-picker>
            至
            <el-date-picker
            v-model="endday"
            style="width: 180px;"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束日期">
          </el-date-picker>
        <button class="buttons" @click="querylist">查询</button>
      </div>
      <div class="componentSty_content_table"  style="top: 90px;border:none">
        <el-table :data="arrlist" border  style="width: 100%; " height="80%">
           <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="plate" label="车牌号"></el-table-column>
		   <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="jtpno" label="焦炭计划号" ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="焦炭派车时间">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.jtpcdate, "时分秒") }}</span>
            </template>
          </el-table-column>
		     <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="yhpno" label="远航计划号" ></el-table-column>
		  <el-table-column show-overflow-tooltip :render-header="renderHeader" label="远航派车时间">
		    <template v-slot="res">
		      <span>{{ mydateFormat(res.row.yhpcdate, "时分秒") }}</span>
		    </template>
		  </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
	import mTitle from "@/components/mTitle";
export default {
  data() {
    return {
      listitem: [{ name: "统计分析" }, { name: "双重车辆查询" }],
      datamsg: [],
      arrlist:[],
      count: "", //车次
      suttlesum: "", //合计净重
      plate:'',
      allnum: 0,
      printable: [],
    };
  },
  computed: {
	  
  },
  components: {
    mTitle,
  },
  created() {
    this.getjobdetails()
  },
  methods: {
    async getjobdetails() {
		
    const { data } = await this.$http(
      "api1",
      "/driver/dispatchtruck/dobuleWeight",
      "get",
      {
		  'plateNo':this.plate,
		  'startDate':this.datamsg[0],
		  'endDate':this.datamsg[1]
	  }
    );
    console.log(data);
    if (data.code != 0) return this.$message.error(data.msg);
	
	if(data){
		 this.arrlist = data.data;
	}
   
    },

    querylist() {
		console.log('this.datamsg.length',this.datamsg)
		if(this.datamsg.length<2){
			this.$message.error("必须选择派车时间！");
			return;
		}
		this.getjobdetails();
    },
    renderHeader(){
      console.log(arguments)
    }
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>